const LightsStatus = { 
   lightsOn: "lightsOn",
  lightsOff: "lightsOff",
  lightsGraduallyOff: "lightsGraduallyOff",
};
  
export default LightsStatus
  
